import React, { Component } from 'react'
import Image from './Image'
import Details from './Details'
import Title from './Title'
import Row from './Row'
import css from './card.module.scss'

export default class Card extends Component {
  static Image = Image
  static Details = Details
  static Title = Title
  static Row = Row

  render() {
    return <div {...this.props} className={css.container} />
  }
}
